<template>
    <div class="page" id="proProfile">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/profile.png" />
        </header>

        <div class="scroller2 green_dark">
            <header>
                <h2 v-if="form.pro">{{ form.pro.first_name }} {{ form.pro.last_name }}</h2>

                <ul class="links">
                    <li>
                        <a class="cancel" @click.prevent="$router.back()" href="#">
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <img
                v-if="form.image && typeof form.image == 'string'"
                style="margin-top: 10px; max-width: 100%; margin-bottom: 30px; border-radius: 12px"
                :src="imageURL(form.image)"
            />

            <span class="profileTitle">Qualifications</span>
            <span class="profileText large">{{ form.qualifications }}</span>

            <span class="profileTitle">Specialisms</span>
            <span class="profileText large">{{ form.specialisms }}</span>

            <span class="profileTitle">Introduction</span>
            <span class="profileText large">{{ form.intro }}</span>

            <span class="profileTitle">Contact email address</span>
            <span class="profileText large">{{ form.email }}</span>

            <span class="profileTitle">Contact telephone</span>
            <span class="profileText large">{{ form.phone }}</span>

            <router-link
                class="proBadge"
                :to="{ name: 'playerProBag', params: { id: form.pro.id } }"
            >
                <img class="bag" src="@/assets/whats-bag2.svg" alt="" />
                <span class="name">{{ form.pro.first_name }} {{ form.pro.last_name }}</span>
                <span class="bagTitle">What's in the bag</span>
                <img class="ar" src="@/assets/arrow-right-white-2.svg" alt="" />
            </router-link>
        </div>
    </div>
</template>

<script>
import { imageURL } from "@/mixins/imageURL.js";
import { XIcon } from "vue-feather-icons";
import { Form } from "vform";
import FadeImage from "@/components/App/fade-image";
export default {
    name: "",
    components: { FadeImage, XIcon },
    created() {
        this.getProfile();
    },
    mixins: [imageURL],
    data() {
        return {
            editMode: false,
            image1: false,
            form: new Form({
                image: "",
                qualifications: "",
                specialisms: "",
                intro: "",
                email: "",
                phone: "",
                pro: false,
            }),
        };
    },
    methods: {
        getProfile() {
            this.form.get("/profile").then((response) => {
                if (!response.data) {
                    this.editMode = true;
                } else {
                    this.form.fill(response.data);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.info {
    background: #bbf8e0;
}
label {
    color: #89978e !important;
}
.cancel {
    color: white !important;
}
.profileTitle {
    color: #8f9990;
    display: block;
}
.profileText {
    color: white;
    display: block;
    padding-top: 10px;
    padding-bottom: 20px;
    border-bottom: 1px solid #414d47;
    margin-bottom: 20px;
    word-wrap: break-word; /* old name */
    overflow-wrap: break-word;
    display: block;
    white-space: pre-line;
    line-height: 1.5;
    &.large {
        font-size: 20px;
    }
}
.fileInput {
    color: white !important;
    padding: 14px 20px;
    input[type="file"] {
        display: none;
    }
}
.proBadge {
    display: block;
    border-radius: $radius;
    background: #444745;
    height: 75px;
    position: relative;
    .bag {
        position: absolute;
        left: 10px;
        bottom: -4px;
    }
    .name,
    .bagTitle {
        display: block;
        color: white;
        font-size: 16px;
    }
    .name {
        font-weight: 200;
        position: absolute;
        left: 80px;
        top: 15px;
    }
    .bagTitle {
        position: absolute;
        left: 80px;
        top: 40px;
    }
    .ar {
        position: absolute;
        right: 20px;
        bottom: 20px;
    }
    text-decoration: none;
}
</style>
